module.exports = __webpack_public_path__ + "img/feedback_icon_2.74660c3d.png";